import type { Alpha3Code } from "i18n-iso-countries/index"
import { ADDRESS_DESER, Address } from "./address"
import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"
import { USA_COUNTRY_CODE } from "./util/country"
import type { DateISOString } from "./util/date-iso-string"

export class EntityBeneficialOwner extends RestResource {
  firstName = ""
  middleName = ""
  lastName = ""
  birthDate: DateISOString | null = null
  email = ""
  citizenshipCountry: Alpha3Code = USA_COUNTRY_CODE
  taxNumber = ""
  useCustomerTaxNumber?: boolean
  ownershipPercent = 0
  address: Address = new Address()
}

export const ENTITY_BENEFICIAL_OWNER_DESER: SchemaDeSer<EntityBeneficialOwner> =
  new SchemaDeSerBuilder(EntityBeneficialOwner)
    .ofString("firstName")
    .ofString("middleName")
    .ofString("lastName")
    .ofString("birthDate")
    .ofString("email")
    .ofString("citizenshipCountry")
    .ofString("taxNumber")
    .ofBoolean("useCustomerTaxNumber")
    .ofFloat("ownershipPercent")
    .ofNested("address", ADDRESS_DESER, Address)
    .ofString("id")
    .toDeSer()
